import { Keys } from '../types';

const keys: Keys = {
  infura: 'daaa68ec242643719749dd1caba2fc66',
  alchemy: 'trix72l2oM0eJK0UB8YfR',
  graph: 'a84caa9e5c322a2faec24ad89ccb9d28',
};

export default keys;
